import { TAdfoxRequestedParams } from '../../../types/adfox';
import { actionGenerator } from '../../../utils/redux/actionGenerator';

export enum EActionTypes {
  SetData = 'adfoxParams/set-data',
}

export const setDataAction = actionGenerator<EActionTypes.SetData, TAdfoxRequestedParams | null>(EActionTypes.SetData);

export type TAdfoxParamsActions = ReturnType<typeof setDataAction>;
